import { render, staticRenderFns } from "./QuestionCreate.vue?vue&type=template&id=3192adfa&"
import script from "./QuestionCreate.vue?vue&type=script&lang=js&"
export * from "./QuestionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports